// Copyright (c) 2019 Deere & Company

import './smart-form-link.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {downloadSmartForm} from '../../services/download-smart-form';

function handleDownloadClick() {

    downloadSmartForm(this.formName, this.objectId);

}

function getIconClassName(icon) {

    const map = {
        PDF: 'button-icon-pdf'
    };

    return map[icon];

}

const SmartFormLink = props => {

    const formattedDisplayText = props.translate ? <FormattedMessage id={props.displayText}/> : props.displayText;

    return (
        <button
            className={props.showAsButton ? 'smart-form-button' : 'button-text smart-form-link'}
            onClick={handleDownloadClick.bind(props)}
        >
            {props.showAsButton && props.showButtonIcon &&
                <span className={getIconClassName(props.icon)}/>
            }
            {formattedDisplayText}
        </button>
    );

};

SmartFormLink.displayName = 'SmartFormLink';
SmartFormLink.propTypes = {
    displayText: PropTypes.string.isRequired,
    formName: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    objectId: PropTypes.string.isRequired,
    showAsButton: PropTypes.bool.isRequired,
    showButtonIcon: PropTypes.bool.isRequired,
    translate: PropTypes.bool.isRequired
};
SmartFormLink.defaultProps = {
    icon: 'NONE',
    showAsButton: false,
    showButtonIcon: false,
    translate: false
};
export default SmartFormLink;



// WEBPACK FOOTER //
// ./src/shared/components/smart-form-link/smart-form-link.js